import { render } from "./Forum-post-comments-comment.vue?vue&type=template&id=eead30b2&lang=pug"
import script from "./Forum-post-comments-comment.vue?vue&type=script&setup=true&lang=js"
export * from "./Forum-post-comments-comment.vue?vue&type=script&setup=true&lang=js"

import "./Forum-post-comments-comment.vue?vue&type=style&index=0&id=eead30b2&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__